/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* ---------------------------------------------------------------------
Global Js
Target Browsers: All
------------------------------------------------------------------------ */

var FX = ( function( FX, $ ) {

	/**
	 * Doc Ready
	 */
	$( function() {
// 		FX.General.init(); // For super general or super short scripts
// 		FX.ImAHuman.init(); // Enable by default
// 		FX.ExternalLinks.init(); // Enable by default
// 		FX.Tabs.init(); // Enable by default for site search page
//         FX.Social.init(); // Open social share in new windows. Used in single.php by default
		// TODO: Add Modules needed for build. Remove unused modules
      
      $('.header__cart-toggle').click(function(){
        
        if ( $(this).attr('aria-expanded')=='false'){
          console.log('Aria Expanded', typeof $(this).attr('aria-expanded'));
          setTimeout(function(){
          	$('.mini-cart').attr('aria-hidden', 'false');
          }, 300);
        }
      });
      
      $("#contact-form-phone-number").attr('maxlength', 13).attr('type', 'tel');
      $("#contact-form-phone-number").on('keyup', function (event) {
        if (event.which !== 8) {
          $(this).val($(this).val().replace(/[^\d]/g, ''));
          var phoneNumberVal = $(this).val().replace(/[^\d]/g, '');
          if (phoneNumberVal != "") {
            $(this).val('(' + phoneNumberVal.substring(0, 3) + ")" +
                        phoneNumberVal.substring(3, 6) + "-" + phoneNumberVal.substring(6))
          }
        }
      });
	});

	$( window ).on( 'load', function() {
		// TODO: Uncomment if using smooth scrolling anchors
		// FX.SmoothAnchors.init();
      
	});
  
  FX.closeMiniCart = function(e){
  	e.preventDefault();
    $('.mini-cart').attr('aria-hidden', 'true');
    $('.header__cart-toggle').attr('aria-expanded', 'false');
  };

	/**
	 * Example Code Block - This should be removed
	 * @type {Object}
	 */
	FX.CodeBlock = {
		init: function() {

		},
	};

	/**
	 * General functionality — ideal for one-liners or super-duper short code blocks
	 */
	FX.General = {
		init: function() {
			this.bind();
		},

		bind: function() {

			// Makes all PDF to open in new tabs
			$('a[href*=".pdf"]').each(function(e) {
				$(this).attr('target', '_blank');
			});			
			
			// Selectric
			$('select').not('.ignore-selectric').selectric({
				arrowButtonMarkup: '<b class="button"></b>'
			});
			
			// IE CSS object-fit support
			objectFitImages();
			
			// pretty-format phone inputs
			$('[type="tel"]').phoneFormat();

			// position: sticky support through polyfill
			var $stickyEls = $('.js-sticky');
			if( $stickyEls.length && typeof( Stickyfill ) === 'object' )
				Stickyfill( $stickyEls );
				
			// FitVids - responsive videos
			$('body').fitVids();

			// TODO: Add additional small scripts below
		}
	};
	
	/**
	 * Slider/Carousel
	 * @type {Object}
	 */
	FX.SlickSlider = {
		init: function() {
			// Fix flashing issue (first slide initially shown)
			$( '.slick-slider' ).on( 'init', function( e, slick ) {
				$( '.slideshow .slide' ).show();
			});

			/* Preloader */
			$( '.js-slider-has-preloader' ).on( 'init', function( e, slick ) {
				$( '.js-slider-has-preloader' ).addClass( 'js-slider-has-preloader-init' );
			});

			$('.slick-slider').slick({ /* Change class based on slider name */
				/* Add settings here*/
			});
		}
	};

	/**
	 * Display scroll-to-top after a certain amount of pixels
	 * @type {Object}
	 */
	FX.BackToTop = {
		$btn: null,

		init: function() {
			this.$btn = $('#back-to-top');
			if( this.$btn.length )
				this.bind();
		},

		bind: function() {
			$(window).on( 'scroll load', this.maybeShowButton.bind( this ) );
			this.$btn.on( 'click', this.scrollToTop );
		},

		maybeShowButton: function() {
			if( $( window ).scrollTop() > 100 ) { // TODO: Update "100" for how far down page to show button
				this.$btn.removeClass( 'hide' );
			} else {
				this.$btn.addClass( 'hide' );
			}
		},

		scrollToTop: function() {
			$(window).scrollTop( 0 );
		}
	};
	
	/**
	 * Mobile menu script for opening/closing menu and sub menus
	 * @type {Object}
	 */
	FX.MobileMenu = {
		init: function() {
			$( '.nav-primary li.menu-item-has-children > a' ).after( '<span class="sub-menu-toggle icon-arrow-down hidden-md-up"></span>' );
			$( '.sub-menu-toggle' ).click( function() {
				var $this = $(this),
					$parent = $this.closest( 'li' ),
					$wrap = $parent.find( '> .sub-menu' );
				$wrap.toggleClass( 'js-toggled' );
				$this.toggleClass( 'js-toggled' );
			});
		}
	};
	
	/**
	 * Force External Links to open in new window.
	 * @type {Object}
	 */
	FX.ExternalLinks = {
		init: function() {
			var siteUrlBase = FX.siteurl.replace( /^https?:\/\/((w){3})?/, '' );
			$( 'a[href*="//"]:not([href*="'+siteUrlBase+'"])' )
				.not( '.ignore-external' ) // ignore class for excluding
				.addClass( 'external' )
				.attr( 'target', '_blank' )
				.attr( 'rel', 'noopener' );
		}
	};
	
	/**
	 * Responsive Tables
	 * @type {Object}
	 */
	FX.ResponsiveTables = {

		init: function() {
			this.bind();
		},

		bind: function() {
			var self = this;

			// Add wrappers to table
			// - change ".page-content table" to appropriate class per project
			$( '.page-content table' ).wrap( '<div class="table-wrap-outer"><div class="table-wrap-inner"></div></div>' );
									
			// Make table draggable
			var mx = 0;
			$( '.table-wrap-inner' ).on({
				mousemove: function( e ) {
					var mx2 = e.pageX - this.offsetLeft;
					if ( mx ) {
						this.scrollLeft = this.sx + mx - mx2;
					}
				},
				mousedown: function( e ) {
					this.sx = this.scrollLeft;
					mx      = e.pageX - this.offsetLeft;
				}
			});

			$( document ).on( 'mouseup', function() {
				mx = 0;
			});
			
			// Add class if table is wider than parent
			$( '.table-wrap-outer' ).find( '.table-wrap-inner table' ).each( function() {
				var $table 			= $( this ),
					$table_outer 	= $table.closest( '.table-wrap-outer' );
				if ( $table.width() > $table_outer.width() ) {
					$table_outer.addClass( 'js-table-is-overflowing' );
					$( '.page-content table' ).before( '<div class="js-table-fade"></div>' );
				}
			});
			
		}
	};

	/**
	 * Custom Social Share icons open windows
	 * Generate URLs, place in a tag and use class - example: https://github.com/bradvin/social-share-urls
	 * @type {Object}
	 */
	FX.Social = {
		init: function() {
			$( '.js-social-share' ).on( 'click', this.open );
		},

		open: function( e ) {
		  e.preventDefault();
		  FX.Social.windowPopup( $( this ).attr( 'href' ), 500, 300 );
		},

		windowPopup: function( url, width, height ) {
			var left = ( screen.width / 2 ) - ( width / 2 ),
				top  = ( screen.height / 2 ) - ( height / 2 );

			window.open(
				url,
				'',
				'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=' + width + ',height=' + height + ',top=' + top + ',left=' + left
			);
		}
	};

	/**
	 * ImAHuman
	 * Hidden Captchas for forms
	 * @type {Object}
	 */
	FX.ImAHuman = {
		init: function() {
			this.bind();
		},

		bind: function() {
			var self = this,
				$forms = $('form');
			
			$forms.each( function() {
				$(this).on( 'focus click', self.markAsHuman );
			});
		},

		markAsHuman: function() {
			$(this).find( '.imahuman, [name="imahuman"]' ).attr( 'value', parseInt( '0xFF9481', 16 ) );
		}
	};


	/**
	 * Affix
	 * Fixes sticky items on scroll
	 * @type {Object}
	 */
	FX.Affix = {
		$body: 			null,
		$header: 		null,
		headerHeight: 	null,
		scrollTimeout: 	null,
		resizeTimeout: 	null,

		init: function() {
			this.$body 			= $(document.body);
			this.$header 		= $('#page-header');
			this.headerHeight 	= this.$header.outerHeight( true );

			this.bind();
        },

        bind: function(e) {
			$(window).on( 'scroll', this.handleScroll.bind( this ) );
			$(window).on( 'resize', this.handleResize.bind( this ) );
		},
		
		handleScroll: function( e ) {
			var self = this;

			// avoid constantly running intensive function(s) on scroll
			if( self.scrollTimeout !== null )
				clearTimeout( self.scrollTimeout );

			setTimeout( function() {
				self.maybeAffixHeader();
			}, 500 );
		},

		handleResize: function( e ) {
			var self = this;

			// avoid constantly running intensive function(s) on resize
			if( self.resizeTimeout !== null )
				clearTimeout( self.resizeTimeout );

			setTimeout( function() {
				self.headerHeight = self.$header.outerHeight( true );
			}, 500 );
		},

		maybeAffixHeader:function() {
			var self = this;

			if( 200 < $(window).scrollTop() ) {
				self.$body.css( 'padding-top', self.headerHeight );
				self.$header.addClass('js-scrolled');
			} else {
				self.$body.css( 'padding-top', 0 );
				self.$header.removeClass('js-scrolled');
			}
		}
	};
	

	/**
	 * FX.Parallax
	 * Parallax effect for images
	 * @type {Object}
	 */
	FX.Parallax = {

		init: function() {
			this.bind();
		},

		bind: function() {
			$( window ).scroll( this.scroll );
		},

		scroll: function( e ) {
			$( '.js-parallax' ).each( function() {
				var $this   = $( this ),
					speed   = $this.data( 'speed' ) || 6,
					yPos    = -( $( window ).scrollTop() / speed ),
					coords  = 'center  '+ yPos + 'px';

				$this.css( { objectPosition: coords } ); /* based on parallax using an object-fit <img> */
			});
		}
	};

	/**
	 * FX.SmoothAnchors
	 * Smoothly Scroll to Anchor ID
	 * @type {Object}
	 */
	FX.SmoothAnchors = {
		init: function() {
			this.hash = window.location.hash;
			if ( this.hash != '' ) {
				this.scrollToSmooth( this.hash );
			}
			this.bind();
		},

		bind: function() {
			$( 'a[href^="#"]' ).on( 'click', $.proxy( this.onClick, this ) );
		},

		onClick: function( e ) {
			e.preventDefault();
			var target = $( e.currentTarget ).attr( 'href' );
			this.scrollToSmooth( target );
		},

		scrollToSmooth: function( target ) {
			var $target = $( target );
			$target = ( $target.length ) ? $target : $( this.hash );

			var headerHeight = 0; // TODO: if using sticky header change 0 to
								  // $('#page-header').outerHeight(true)

			if ( $target.length ) {
				var targetOffset = $target.offset().top - headerHeight;
				$( 'html, body' ).animate( { scrollTop: targetOffset }, 600 );
				return false;
			}
		}
	};

	/**
	 * Tab Content
	 * @type {Object}
	 */
	 
	FX.Tabs = {
		init: function() {
			$( '.js-tabs' ).on( 'click touchstart', 'a', this.switchTab );
		},
		switchTab: function( e ) {
			e.preventDefault();
			var $this = $( this ),
				$tab  = $( $this.attr( 'href' ) );

			$this.parent()
				 .addClass( 'tab-active show' )
				 .siblings()
				 .removeClass( 'tab-active show' );

			$tab.addClass( 'tab-active show' )
				.siblings()
				.removeClass( 'tab-active show' );
		}
	};

	return FX;

}(FX || {}, jQuery));

